"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const contacts_1 = require("./contacts");
const groups_1 = require("./groups");
const legacyReportsWeeklyGeneral_1 = require("./legacyReportsWeeklyGeneral");
const legacyReportsWeeklyTrapCatches_1 = require("./legacyReportsWeeklyTrapCatches");
const legacyReportsWeeklyTrapIssues_1 = require("./legacyReportsWeeklyTrapIssues");
const legacyV3Alerts_1 = require("./legacyV3Alerts");
const legacyWeatherForecastAlerts_1 = require("./legacyWeatherForecastAlerts");
const user_1 = require("./user");
exports.requestSchema = zod_1.z
    .object({
    contacts: contacts_1.contacts.optional(),
    groups: groups_1.groups.optional(),
    legacyReportsWeeklyGeneral: legacyReportsWeeklyGeneral_1.legacyReportsWeeklyGeneral.optional(),
    legacyReportsWeeklyTrapCatches: legacyReportsWeeklyTrapCatches_1.legacyReportsWeeklyTrapCatches.optional(),
    legacyReportsWeeklyTrapIssues: legacyReportsWeeklyTrapIssues_1.legacyReportsWeeklyTrapIssues.optional(),
    legacyV3Alerts: legacyV3Alerts_1.legacyV3Alerts.optional(),
    legacyWeatherForecastAlerts: legacyWeatherForecastAlerts_1.legacyWeatherForecastAlerts.optional(),
    user: user_1.user.optional(),
})
    .refine((args) => !args || !!Object.keys(args || {}).length, {
    // NOTE: keep this up to date
    message: 'Must request at least one attribute amongst user, contacts, groups, legacyReportsWeeklyGeneral, legacyReportsWeeklyTrapCatches, legacyReportsWeeklyTrapIssues, legacyV3Alerts, legacyWeatherForecastAlerts',
});
exports.path = '/user-profile';
//# sourceMappingURL=index.js.map